export const BASE_URL = "https://deliveryapi.meander.software/"